import { useMutation, useQueryClient } from "@tanstack/react-query";

import stellar from "@/services/stellar";
import type { SupplierPayload, SupplierResource } from "../types";

type SupplierUpdatePayload = SupplierPayload & { id: string };

const updateSupplier = async (payload: SupplierUpdatePayload) => {
  const response = (await stellar.action("editSupplier", payload)) as {
    supplier?: SupplierResource;
  };

  return response.supplier ?? (payload as SupplierResource);
};

export const useUpdateSupplierMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSupplier,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["suppliers"] });
    },
  });
};
